interface ServiceConfigData {
    serviceType: string;
    serviceAddress?: string;
}


const ServiceConfigApis = {
    async getServiceConfig(): Promise<ServiceConfigData> {
        const res = await window.LinkService?.request('/api/main/v1/serviceConfig/getServiceConfig');
        console.log('getServiceConfig = ', res);
        return res?.data as ServiceConfigData;
    },
    async setServiceConfig(data: ServiceConfigData): Promise<boolean> {
        const res = await window.LinkService?.request('/api/main/v1/serviceConfig/setServiceConfig', { ...data });
        return res.code === 200;
    },
};

export default ServiceConfigApis;